/* =============================================================
   ZoneMarket — Template Produit JS
   zm-product.js  |  Vanilla JS uniquement  |  v1.0
   ============================================================= */

(function () {
  'use strict';

  /* ─── Galerie photos ──────────────────────────────────────── */
  function initGallery() {
    const gallery = document.querySelector('.zm-hero__gallery');
    if (!gallery) return;

    const mainImg   = gallery.querySelector('.zm-gallery__main-img');
    const mainVideo = gallery.querySelector('.zm-gallery__main-video');
    const thumbs    = gallery.querySelectorAll('.zm-gallery__thumb');
    const soundBtn  = gallery.querySelector('.zm-gallery__sound-btn');

    if (!thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');

        const type = thumb.dataset.type || 'image';
        const src  = thumb.dataset.src;

        if (type === 'video' && mainVideo) {
          if (mainImg) mainImg.style.display = 'none';
          mainVideo.style.display = 'block';
          mainVideo.src = src;
          mainVideo.play();
          if (soundBtn) soundBtn.style.display = 'flex';
        } else if (mainImg) {
          if (mainVideo) {
            mainVideo.pause();
            mainVideo.style.display = 'none';
            if (soundBtn) soundBtn.style.display = 'none';
          }
          mainImg.style.display = 'block';
          mainImg.src = src;
          mainImg.dataset.highres = thumb.dataset.highres || src;
        }
      });
    });
  }

  /* ─── Son vidéo hero ──────────────────────────────────────── */
  function initVideoSound() {
    const soundBtn = document.querySelector('.zm-gallery__sound-btn');
    const video    = document.querySelector('.zm-gallery__main-video');
    if (!soundBtn || !video) return;

    soundBtn.addEventListener('click', function () {
      video.muted = !video.muted;
      soundBtn.innerHTML = video.muted
        ? '🔇 Activer le son'
        : '🔊 Couper le son';
    });
  }

  /* ─── Sélecteur quantité ──────────────────────────────────── */
  function initQuantity() {
    document.querySelectorAll('.zm-quantity').forEach(function (wrap) {
      const input   = wrap.querySelector('.zm-quantity__input');
      const btnMinus = wrap.querySelector('[data-action="minus"]');
      const btnPlus  = wrap.querySelector('[data-action="plus"]');
      if (!input) return;

      if (btnMinus) {
        btnMinus.addEventListener('click', function () {
          const val = parseInt(input.value, 10);
          if (val > 1) input.value = val - 1;
          syncQuantity(input);
        });
      }

      if (btnPlus) {
        btnPlus.addEventListener('click', function () {
          const val = parseInt(input.value, 10);
          const max = parseInt(input.max, 10) || 99;
          if (val < max) input.value = val + 1;
          syncQuantity(input);
        });
      }

      input.addEventListener('change', function () {
        let val = parseInt(input.value, 10);
        if (isNaN(val) || val < 1) val = 1;
        input.value = val;
        syncQuantity(input);
      });
    });
  }

  function syncQuantity(input) {
    /* Synchronise tous les inputs quantité de la page */
    document.querySelectorAll('.zm-quantity__input').forEach(function (inp) {
      if (inp !== input) inp.value = input.value;
    });
  }

  /* ─── FAQ accordéon ───────────────────────────────────────── */
  function initFAQ() {
    document.querySelectorAll('.zm-faq-item__question').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const item   = btn.closest('.zm-faq-item');
        const isOpen = item.classList.contains('is-open');

        /* Ferme tout */
        document.querySelectorAll('.zm-faq-item.is-open').forEach(function (el) {
          el.classList.remove('is-open');
        });

        /* Ouvre si était fermé */
        if (!isOpen) item.classList.add('is-open');
      });
    });
  }

  /* ─── Sticky CTA mobile ───────────────────────────────────── */
  function initStickyCTA() {
    const cta = document.querySelector('.zm-sticky-cta');
    if (!cta) return;

    let lastScroll = 0;
    let ticking    = false;

    window.addEventListener('scroll', function () {
      lastScroll = window.pageYOffset;
      if (!ticking) {
        window.requestAnimationFrame(function () {
          if (lastScroll > 600) {
            cta.classList.add('is-visible');
          } else {
            cta.classList.remove('is-visible');
          }
          ticking = false;
        });
        ticking = true;
      }
    });

    /* Clic → scroll vers le bouton EasySell / hero */
    cta.querySelector('.zm-sticky-cta__btn') &&
      cta.querySelector('.zm-sticky-cta__btn').addEventListener('click', function () {
        const target = document.querySelector('#zm-buy-btn');
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(function () { target.click(); }, 400);
        }
      });
  }

  /* ─── Lazy load images ────────────────────────────────────── */
  function initLazyImages() {
    if (!('IntersectionObserver' in window)) {
      /* Fallback navigateurs anciens */
      document.querySelectorAll('img[data-src]').forEach(function (img) {
        img.src = img.dataset.src;
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.classList.add('is-loaded');
      });
      return;
    }

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        const img = entry.target;
        img.src = img.dataset.src;
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.classList.add('is-loaded');
        observer.unobserve(img);
      });
    }, { rootMargin: '200px 0px' });

    document.querySelectorAll('img[data-src]').forEach(function (img) {
      observer.observe(img);
    });
  }

  /* ─── Meta Pixel events ───────────────────────────────────── */
  function firePixelViewContent() {
    if (typeof fbq !== 'function') return;
    var productData = window.zmProductData || {};
    fbq('track', 'ViewContent', {
      content_ids:  [productData.id  || ''],
      content_name: productData.title || '',
      content_type: 'product',
      value:        productData.price || 0,
      currency:     'GNF'
    });
  }

  function initCheckoutPixel() {
    if (typeof fbq !== 'function') return;
    var productData = window.zmProductData || {};

    /* Déclenche InitiateCheckout au clic sur n'importe quel bouton d'achat */
    document.querySelectorAll('.zm-buy-btn, #zm-buy-btn, [data-zm-buy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        fbq('track', 'InitiateCheckout', {
          content_ids:  [productData.id  || ''],
          content_name: productData.title || '',
          value:        productData.price || 0,
          currency:     'GNF'
        });
      });
    });
  }

  /* ─── Variante sélectionnée → mise à jour prix ────────────── */
  function initVariantSelector() {
    const form = document.querySelector('.zm-product-form');
    if (!form) return;

    form.querySelectorAll('[name="id"]').forEach(function (select) {
      select.addEventListener('change', function () {
        updatePriceDisplay(select.value);
      });
    });
  }

  function updatePriceDisplay(variantId) {
    if (!window.zmVariants) return;
    const variant = window.zmVariants.find(function (v) {
      return String(v.id) === String(variantId);
    });
    if (!variant) return;

    const priceEl = document.querySelector('.zm-price-current');
    const origEl  = document.querySelector('.zm-price-original');

    if (priceEl) {
      priceEl.textContent = formatMoney(variant.price) + ' GNF';
    }
    if (origEl && variant.compare_at_price) {
      origEl.textContent = formatMoney(variant.compare_at_price) + ' GNF';
    }
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('fr-GN');
  }

  /* ─── Init ────────────────────────────────────────────────── */
  function init() {
    initGallery();
    initVideoSound();
    initQuantity();
    initFAQ();
    initStickyCTA();
    initLazyImages();
    initVariantSelector();
    firePixelViewContent();
    initCheckoutPixel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init après chargement de section via le customizer Shopify */
  document.addEventListener('shopify:section:load', init);

}());
